import API from "@/models/API";

export default class Register {
    static sendVerificationSMS = (body) => API.post(`/users/forgot-password`, body);

    static updatePassword = (body) => API.post(`/users/update-password`, body);
}
